import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_RunAction.scss';
export class Renderer_RunAction extends ComponentSync {
    render() {
        return _jsxs(LL_H_C, { className: 'advisor-setting__run-action', onClick: this.props.action, children: [_jsx("div", { className: 'run-action__action-label', children: this.props.label }), _jsx("div", { className: 'run-action__run-label', children: "Run" })] });
    }
}
//# sourceMappingURL=Renderer_RunAction.js.map